import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../../components/feature/SEOHead';
import ExercicioGratisNavbar from '../exercicio-gratis/components/ExercicioGratisNavbar';
import QuizDiagnostico from './components/QuizDiagnostico';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schema = [
  {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Exercícios de PNL Gratuitos | Bia Holmes',
    url: `${SITE_URL}/exercicios-gratis`,
    description: 'Explore 12 exercícios gratuitos de PNL e desenvolvimento pessoal. Técnicas comprovadas para transformar sua vida: emoções, carreira, saúde, relacionamentos e muito mais.',
  },
];

const exercises = [
  {
    slug: 'tecnica-swish-pnl',
    title: 'Técnica Swish',
    subtitle: 'PNL',
    description: 'Substitua padrões mentais indesejados por comportamentos de alta performance em minutos.',
    category: 'PNL Clássica',
    icon: 'ri-refresh-line',
    time: '10 min',
    level: 'Iniciante',
    praticantes: '3.847',
  },
  {
    slug: 'ancoragem-emocional',
    title: 'Ancoragem Emocional',
    subtitle: 'PNL',
    description: 'Crie gatilhos instantâneos para acessar estados emocionais positivos sempre que precisar.',
    category: 'Controle Emocional',
    icon: 'ri-anchor-line',
    time: '15 min',
    level: 'Iniciante',
    praticantes: '5.129',
  },
  {
    slug: 'encantations-tony-robbins',
    title: 'Encantations',
    subtitle: 'Tony Robbins',
    description: 'Reprograme seu sistema nervoso com palavras, movimento e emoção genuína.',
    category: 'Estado Mental',
    icon: 'ri-fire-line',
    time: '12 min',
    level: 'Iniciante',
    praticantes: '2.943',
  },
  {
    slug: 'linha-tempo-pnl',
    title: 'Linha do Tempo',
    subtitle: 'PNL',
    description: 'Reorganize sua história pessoal e liberte-se de emoções negativas do passado.',
    category: 'Cura Emocional',
    icon: 'ri-time-line',
    time: '20 min',
    level: 'Intermediário',
    praticantes: '4.201',
  },
  {
    slug: 'ressignificacao-reframing-pnl',
    title: 'Ressignificação',
    subtitle: 'Reframing PNL',
    description: 'Transforme situações limitantes em perspectivas empoderadoras mudando o significado.',
    category: 'Crenças',
    icon: 'ri-eye-line',
    time: '15 min',
    level: 'Iniciante',
    praticantes: '3.562',
  },
  {
    slug: 'submodalidades-pnl',
    title: 'Submodalidades',
    subtitle: 'PNL',
    description: 'Descubra os controles internos da sua mente e ajuste a intensidade das experiências.',
    category: 'PNL Avançada',
    icon: 'ri-settings-3-line',
    time: '20 min',
    level: 'Avançado',
    praticantes: '1.876',
  },
  {
    slug: 'modelagem-excelencia-pnl',
    title: 'Modelagem de Excelência',
    subtitle: 'PNL',
    description: 'Replique padrões de sucesso de pessoas que já alcançaram o que você deseja.',
    category: 'Sucesso',
    icon: 'ri-star-line',
    time: '25 min',
    level: 'Intermediário',
    praticantes: '2.134',
  },
  {
    slug: 'identidade-alta-performance',
    title: 'Identidade de Alta Performance',
    subtitle: 'PNL',
    description: 'Transforme sua identidade e torne-se a versão que alcança resultados extraordinários.',
    category: 'Performance',
    icon: 'ri-user-star-line',
    time: '30 min',
    level: 'Avançado',
    praticantes: '2.891',
  },
  {
    slug: 'proposito-vida',
    title: 'Propósito de Vida',
    subtitle: 'Autoconhecimento',
    description: 'Conecte-se com sua missão única no mundo e viva alinhado com seus valores essenciais.',
    category: 'Autoconhecimento',
    icon: 'ri-compass-3-line',
    time: '35 min',
    level: 'Iniciante',
    praticantes: '4.567',
  },
  {
    slug: 'prosperidade-carreira',
    title: 'Prosperidade e Carreira',
    subtitle: 'Manifestação',
    description: 'Manifeste abundância financeira e sucesso profissional através da reprogramação mental.',
    category: 'Finanças',
    icon: 'ri-money-dollar-circle-line',
    time: '20 min',
    level: 'Iniciante',
    praticantes: '3.234',
  },
  {
    slug: 'saude-bem-estar',
    title: 'Saúde e Bem-Estar',
    subtitle: 'Mente-Corpo',
    description: 'Conecte-se com seu corpo ideal e manifeste saúde plena através da visualização.',
    category: 'Saúde',
    icon: 'ri-heart-pulse-line',
    time: '18 min',
    level: 'Iniciante',
    praticantes: '2.789',
  },
  {
    slug: 'amor-ideal',
    title: 'Amor Ideal',
    subtitle: 'Manifestação',
    description: 'Conecte-se com a energia do relacionamento ideal e manifeste o amor que você merece.',
    category: 'Relacionamentos',
    icon: 'ri-heart-3-line',
    time: '25 min',
    level: 'Iniciante',
    praticantes: '3.456',
  },
];

const categories = ['Todos', 'PNL Clássica', 'Controle Emocional', 'Estado Mental', 'Cura Emocional', 'Crenças', 'Performance', 'Sucesso', 'Autoconhecimento', 'Finanças', 'Saúde', 'Relacionamentos', 'PNL Avançada'];

const levelColors: Record<string, string> = {
  Iniciante: 'text-emerald-600 bg-emerald-50 border-emerald-200',
  Intermediário: 'text-amber-700 bg-amber-50 border-amber-200',
  Avançado: 'text-rose-700 bg-rose-50 border-rose-200',
};

const testimonials = [
  {
    name: 'Camila Ferreira',
    role: 'Analista de Marketing, SP',
    avatar: 'https://public.readdy.ai/ai/img_res/87aef84b7722cf994230fb7129080983.jpg',
    before: 'Sofria de ansiedade constante no trabalho. Me sentia paralisada diante de desafios e evitava apresentações. Minha autoestima estava no chão.',
    after: 'Depois de praticar a Ancoragem Emocional por 3 semanas, passei a acessar calma e confiança sob demanda. Fiz minha melhor apresentação na empresa!',
    exercise: 'Ancoragem Emocional',
    stars: 5,
    result: 'Ansiedade eliminada',
  },
  {
    name: 'Marcos Oliveira',
    role: 'Empreendedor, RJ',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20man%20confident%20smiling%20natural%20portrait%20soft%20cream%20background%20warm%20tones%20elegant%2040%20years%20old%20business%20casual&width=80&height=80&seq=av02&orientation=squarish',
    before: 'Passava anos sabotando meu sucesso financeiro. Cada vez que crescia, algo me fazia recuar. Não conseguia fechar contratos grandes por medo.',
    after: 'A Técnica Swish e o exercício de Prosperidade me libertaram das crenças limitantes. Em 60 dias fechei 3 contratos que antes eu fugiria.',
    exercise: 'Técnica Swish + Prosperidade',
    stars: 5,
    result: '+3 contratos fechados',
  },
  {
    name: 'Juliana Santos',
    role: 'Professora universitária, MG',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%20teacher%20smiling%20natural%20portrait%20soft%20cream%20background%20warm%20tones%20elegant%2038%20years%20old%20intellectual&width=80&height=80&seq=av03&orientation=squarish',
    before: 'Carregava mágoa de relacionamentos passados há mais de 5 anos. Repetia os mesmos padrões em todas as relações e não conseguia me abrir para o amor.',
    after: 'A Linha do Tempo mudou tudo. Liberei emoções presas e em 4 meses encontrei um relacionamento saudável. Nunca me senti tão leve e aberta.',
    exercise: 'Linha do Tempo PNL',
    stars: 5,
    result: 'Relacionamento saudável em 4 meses',
  },
];

const beforeAfterStats = [
  { icon: 'ri-emotion-happy-line', label: 'Relatam melhora emocional após 1ª semana', value: '89%' },
  { icon: 'ri-arrow-up-line', label: 'Aumentam produtividade nos primeiros 30 dias', value: '74%' },
  { icon: 'ri-heart-line', label: 'Melhoram relacionamentos em 60 dias', value: '67%' },
  { icon: 'ri-vip-crown-line', label: 'Passam para o plano completo após experimentar', value: '3 em 5' },
];

interface ExercicioModalData {
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  category: string;
  icon: string;
  time: string;
  level: string;
  praticantes: string;
  passos: string[];
  beneficios: string[];
}

const exerciciosDetalhes: Record<string, Pick<ExercicioModalData, 'passos' | 'beneficios'>> = {
  'tecnica-swish-pnl': {
    passos: [
      'Identifique o comportamento ou emoção que quer mudar',
      'Descubra o gatilho mental (imagem interna)',
      'Crie a imagem do seu EU IDEAL na mesma situação',
      'Execute o movimento SWISH — troca rápida das imagens',
      'Repita 5 vezes e teste o resultado',
    ],
    beneficios: ['Substitui hábitos indesejados', 'Age no nível subconsciente', 'Resultados em minutos'],
  },
  'ancoragem-emocional': {
    passos: [
      'Escolha o estado emocional que deseja ancorar (ex: confiança)',
      'Lembre-se de uma experiência intensa desse estado',
      'Reviva esse momento com toda a intensidade',
      'Aplique o gatilho físico no pico da emoção',
      'Teste a âncora e fortaleça com repetições',
    ],
    beneficios: ['Estados emocionais sob demanda', 'Reduz ansiedade rapidamente', 'Aumenta performance'],
  },
  'encantations-tony-robbins': {
    passos: [
      'Escolha uma crença limitante que quer substituir',
      'Crie uma afirmação poderosa no presente',
      'Adicione movimento físico intenso ao dizer a frase',
      'Repita com toda a emoção e convicção por 5 minutos',
      'Pratique diariamente por 21 dias',
    ],
    beneficios: ['Instala crenças no sistema nervoso', 'Combina mente e corpo', 'Resultados duradouros'],
  },
  'linha-tempo-pnl': {
    passos: [
      'Feche os olhos e visualize sua linha do tempo pessoal',
      'Identifique um evento passado que ainda gera emoção negativa',
      'Flutue acima da linha do tempo para ver o evento de fora',
      'Extraia o aprendizado e libere as emoções negativas',
      'Programe eventos positivos no seu futuro',
    ],
    beneficios: ['Libera traumas do passado', 'Clareza sobre o futuro', 'Cura emocional profunda'],
  },
  'ressignificacao-reframing-pnl': {
    passos: [
      'Identifique a situação ou crença limitante',
      'Pergunte: "Que outro significado esta situação pode ter?"',
      'Busque pelo menos 3 perspectivas diferentes',
      'Escolha a perspectiva mais empoderada',
      'Ancora a nova perspectiva com uma emoção positiva',
    ],
    beneficios: ['Transforma perspectivas limitantes', 'Aumenta a resiliência', 'Gera novas soluções'],
  },
  'submodalidades-pnl': {
    passos: [
      'Visualize a memória ou situação problemática',
      'Observe as qualidades da imagem (tamanho, cor, distância)',
      'Altere gradualmente cada qualidade da imagem',
      'Note como cada alteração muda a intensidade emocional',
      'Encontre a configuração ideal para seu bem-estar',
    ],
    beneficios: ['Controla intensidade emocional', 'Alta precisão mental', 'Alívio rápido de fobias'],
  },
  'modelagem-excelencia-pnl': {
    passos: [
      'Escolha uma pessoa que já alcançou o que você quer',
      'Observe e estude seus padrões de comportamento',
      'Identifique as crenças e valores por trás das ações',
      'Experimente "ser" essa pessoa mentalmente',
      'Integre os padrões que funcionam para você',
    ],
    beneficios: ['Acelerador de aprendizagem', 'Replica padrões de sucesso', 'Expansão de identidade'],
  },
  'identidade-alta-performance': {
    passos: [
      'Defina claramente quem é sua versão de alta performance',
      'Liste os valores e crenças dessa versão',
      'Escreva como ela pensa, age e se comunica',
      'Visualize-se sendo essa pessoa em detalhes vívidos',
      'Tome uma ação hoje como essa versão sua',
    ],
    beneficios: ['Cria identidade vencedora', 'Alinha comportamentos aos objetivos', 'Resultados extraordinários'],
  },
  'proposito-vida': {
    passos: [
      'Liste o que te faz perder a noção do tempo',
      'Identifique o que o mundo precisa que você pode oferecer',
      'Conecte suas habilidades com sua paixão',
      'Escreva sua declaração de propósito pessoal',
      'Tome uma ação alinhada ao seu propósito hoje',
    ],
    beneficios: ['Clareza de direção', 'Mais motivação e energia', 'Decisões mais fáceis'],
  },
  'prosperidade-carreira': {
    passos: [
      'Identifique suas crenças sobre dinheiro e sucesso',
      'Desafie cada crença limitante encontrada',
      'Crie uma visão clara da sua prosperidade ideal',
      'Visualize com detalhes emocionais intensos',
      'Tome ações alinhadas à sua nova identidade próspera',
    ],
    beneficios: ['Remove bloqueios financeiros', 'Atrai oportunidades', 'Mentalidade de abundância'],
  },
  'saude-bem-estar': {
    passos: [
      'Crie uma imagem vívida do seu corpo e saúde ideais',
      'Sinta as emoções de ter essa saúde agora',
      'Identifique hábitos que a versão saudável pratica',
      'Ancora a sensação de bem-estar no corpo',
      'Crie um plano de ação para o primeiro hábito',
    ],
    beneficios: ['Motivação intrínseca para saúde', 'Conexão mente-corpo', 'Hábitos duradouros'],
  },
  'amor-ideal': {
    passos: [
      'Escreva as qualidades do relacionamento ideal',
      'Identifique padrões passados que se repetem',
      'Ressignifique experiências anteriores com PNL',
      'Visualize-se em seu relacionamento ideal',
      'Pratique amor-próprio como base de tudo',
    ],
    beneficios: ['Quebra padrões relacionais', 'Atrai relacionamento saudável', 'Fortalece auto-amor'],
  },
};

function ExercicioModal({ exercicio, onClose }: {
  exercicio: ExercicioModalData;
  onClose: () => void;
}) {
  const detalhes = exerciciosDetalhes[exercicio.slug] || { passos: [], beneficios: [] };

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4"
      onClick={onClose}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

      {/* Modal */}
      <div
        className="relative w-full sm:max-w-lg bg-white rounded-t-3xl sm:rounded-3xl overflow-hidden max-h-[92vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-gradient-to-br from-charcoal-950 to-charcoal-900 px-6 pt-6 pb-5 shrink-0">
          <div className="flex items-start justify-between gap-3 mb-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-gold-500/15 border border-gold-500/25 shrink-0">
              <i className={`${exercicio.icon} text-2xl text-gold-400`} />
            </div>
            <button
              onClick={onClose}
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 text-white/60 hover:bg-white/20 hover:text-white transition-all cursor-pointer shrink-0"
            >
              <i className="ri-close-line text-lg" />
            </button>
          </div>
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <span className="text-[10px] font-bold text-gold-400 bg-gold-500/15 border border-gold-500/25 px-2.5 py-1 rounded-full tracking-widest uppercase">
              {exercicio.category}
            </span>
            <span className={`text-[10px] font-bold border px-2.5 py-1 rounded-full ${levelColors[exercicio.level]}`}>
              {exercicio.level}
            </span>
          </div>
          <h2 className="font-display text-xl font-bold text-white leading-tight mb-1">
            {exercicio.title}
          </h2>
          <p className="text-gold-400 text-xs font-semibold tracking-wide">{exercicio.subtitle}</p>
          <div className="flex items-center gap-4 mt-3 text-xs text-white/40">
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line text-gold-500" />
              {exercicio.time}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-group-line text-gold-500" />
              {exercicio.praticantes} praticantes
            </span>
          </div>
        </div>

        {/* Conteúdo scrollável */}
        <div className="overflow-y-auto flex-1 px-6 py-5 space-y-5">
          {/* Descrição */}
          <p className="text-charcoal-600 text-sm leading-relaxed">{exercicio.description}</p>

          {/* Benefícios */}
          <div>
            <p className="text-[10px] font-bold text-charcoal-400 uppercase tracking-widest mb-3">O que você vai alcançar</p>
            <div className="flex flex-wrap gap-2">
              {detalhes.beneficios.map((b, i) => (
                <span key={i} className="flex items-center gap-1.5 text-xs font-semibold text-gold-700 bg-gold-50 border border-gold-200 px-3 py-1.5 rounded-full">
                  <i className="ri-checkbox-circle-fill text-gold-500 text-xs" />
                  {b}
                </span>
              ))}
            </div>
          </div>

          {/* Passos */}
          <div>
            <p className="text-[10px] font-bold text-charcoal-400 uppercase tracking-widest mb-3">Passos do exercício</p>
            <div className="space-y-2.5">
              {detalhes.passos.map((passo, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-charcoal-900 text-gold-400 text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">
                    {i + 1}
                  </div>
                  <p className="text-sm text-charcoal-600 leading-relaxed">{passo}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA fixo no rodapé */}
        <div className="shrink-0 px-6 py-4 border-t border-charcoal-100 bg-white">
          <Link
            to={`/exercicio-gratis/${exercicio.slug}`}
            className="flex items-center justify-center gap-2 w-full py-3.5 bg-gradient-to-r from-gold-500 to-gold-700 text-charcoal-900 rounded-xl font-bold text-sm tracking-wide hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap"
            onClick={onClose}
          >
            <i className="ri-play-circle-line text-lg" />
            Começar exercício — Grátis
          </Link>
          <p className="text-center text-xs text-charcoal-400 mt-2">
            Sem cadastro · Acesso imediato
          </p>
        </div>
      </div>
    </div>
  );
}

export default function ExerciciosGratisIndexPage() {
  const [activeCategory, setActiveCategory] = useState('Todos');
  const [exercicioModal, setExercicioModal] = useState<ExercicioModalData | null>(null);

  const filtered = activeCategory === 'Todos'
    ? exercises
    : exercises.filter(e => e.category === activeCategory);

  const abrirModal = (exercise: typeof exercises[0]) => {
    setExercicioModal({ ...exercise });
  };

  return (
    <div className="min-h-screen bg-cream-50">
      <SEOHead
        title="12 Exercícios de PNL Gratuitos | Técnicas Comprovadas — Bia Holmes"
        description="Explore 12 exercícios gratuitos de PNL e desenvolvimento pessoal. Técnicas comprovadas para transformar emoções, carreira, saúde e relacionamentos. Comece agora sem custo."
        keywords="exercícios PNL grátis, técnicas PNL, desenvolvimento pessoal gratuito, ancoragem emocional, técnica swish, ressignificação"
        canonical="/exercicios-gratis"
        schema={schema}
      />

      <ExercicioGratisNavbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-charcoal-950 via-charcoal-900 to-charcoal-950 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-gold-500/6 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-gold-400/5 rounded-full blur-3xl"></div>
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(201,164,64,0.04)_0%,_transparent_60%)]"></div>
        </div>
        <div className="max-w-5xl mx-auto relative z-10 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold-500/10 border border-gold-500/25 rounded-full text-gold-400 text-xs font-semibold tracking-widest uppercase mb-8">
            <i className="ri-sparkling-2-line text-base"></i>
            Acesso Gratuito Imediato
          </div>
          <h1 className="font-display text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Exercícios de PNL<br />
            <span className="text-gold-400">Totalmente Gratuitos</span>
          </h1>
          <p className="text-xl text-white/60 max-w-2xl mx-auto mb-12 font-light leading-relaxed">
            12 técnicas de Programação Neurolinguística comprovadas para transformar emoções, ampliar resultados e criar a vida que você merece — sem custo algum.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <div className="flex items-center gap-2 text-white/50">
              <i className="ri-checkbox-circle-fill text-gold-500 text-base"></i>
              12 técnicas disponíveis
            </div>
            <div className="flex items-center gap-2 text-white/50">
              <i className="ri-checkbox-circle-fill text-gold-500 text-base"></i>
              Sem cadastro necessário
            </div>
            <div className="flex items-center gap-2 text-white/50">
              <i className="ri-checkbox-circle-fill text-gold-500 text-base"></i>
              Baseado em PNL clínica
            </div>
          </div>
        </div>
      </section>

      {/* Stats strip */}
      <div className="bg-charcoal-900 border-b border-gold-500/10">
        <div className="max-w-5xl mx-auto px-6 py-4 flex flex-wrap justify-center gap-8">
          {[
            { value: '12', label: 'Exercícios Gratuitos' },
            { value: '10k+', label: 'Vidas Transformadas' },
            { value: '100%', label: 'Baseado em PNL' },
            { value: 'R$ 0', label: 'Custo para Começar' },
          ].map((s, i) => (
            <div key={i} className="text-center">
              <div className="font-display text-2xl font-bold text-gold-400">{s.value}</div>
              <div className="text-xs text-white/40 tracking-wide">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      <QuizDiagnostico />

      {/* Filter & Grid */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-display text-3xl font-bold text-charcoal-900 mb-2">Escolha seu exercício</h2>
            <p className="text-charcoal-500 text-sm">Clique em qualquer card para ver os detalhes e começar</p>
          </div>

          {/* Category filter */}
          <div className="flex flex-wrap gap-2 mb-12 justify-center">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-2 rounded-full text-xs font-semibold tracking-wide whitespace-nowrap transition-all cursor-pointer ${
                  activeCategory === cat
                    ? 'bg-gradient-to-r from-gold-500 to-gold-700 text-charcoal-900 border border-gold-500'
                    : 'bg-white text-charcoal-500 border border-charcoal-200 hover:border-gold-400 hover:text-gold-600'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filtered.map((exercise) => (
              <button
                key={exercise.slug}
                onClick={() => abrirModal(exercise)}
                className="group bg-white rounded-2xl border border-charcoal-100 hover:border-gold-300 hover:shadow-lg transition-all duration-300 overflow-hidden flex flex-col cursor-pointer text-left"
              >
                <div className="h-1 w-full bg-gradient-to-r from-gold-500 to-gold-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="w-12 h-12 flex items-center justify-center mb-4 rounded-xl bg-charcoal-50 group-hover:bg-gold-50 border border-charcoal-100 group-hover:border-gold-200 transition-all duration-300">
                    <i className={`${exercise.icon} text-2xl text-charcoal-400 group-hover:text-gold-600 transition-colors duration-300`}></i>
                  </div>
                  <div className="flex items-center gap-2 mb-3 flex-wrap">
                    <span className="text-xs font-semibold text-gold-600 bg-gold-50 border border-gold-200 px-2.5 py-1 rounded-full tracking-wide">
                      {exercise.category}
                    </span>
                    <span className={`text-xs font-semibold border px-2.5 py-1 rounded-full ${levelColors[exercise.level]}`}>
                      {exercise.level}
                    </span>
                  </div>
                  <h3 className="font-display text-lg font-bold text-charcoal-800 mb-1 leading-snug group-hover:text-charcoal-900 transition-colors">
                    {exercise.title}
                  </h3>
                  <p className="text-xs text-gold-500 font-semibold tracking-wide mb-3">
                    {exercise.subtitle}
                  </p>
                  <p className="text-sm text-charcoal-500 font-light leading-relaxed flex-1 mb-5">
                    {exercise.description}
                  </p>
                  <div className="flex items-center justify-between mt-auto pt-3 border-t border-charcoal-50">
                    <div className="flex items-center gap-3 text-xs text-charcoal-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line text-gold-400"></i>
                        {exercise.time}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-group-line text-gold-400"></i>
                        {exercise.praticantes}
                      </span>
                    </div>
                    <span className="text-xs font-semibold text-gold-600 group-hover:text-gold-700 flex items-center gap-1 transition-colors">
                      Ver detalhes
                      <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                    </span>
                  </div>
                </div>
              </button>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-20 text-charcoal-400">
              <i className="ri-search-line text-4xl mb-4 block text-charcoal-300"></i>
              Nenhum exercício encontrado para esta categoria.
            </div>
          )}
        </div>
      </section>

      {/* ─── ANTES & DEPOIS ─── */}
      <section className="py-24 px-6 bg-white border-t border-gold-100">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold-50 border border-gold-200 rounded-full text-gold-700 text-xs font-semibold tracking-widest uppercase mb-6">
              <i className="ri-star-fill text-gold-500"></i>
              Resultados Reais
            </div>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-charcoal-900 mb-4 leading-tight">
              Antes &amp; Depois
            </h2>
            <p className="text-charcoal-500 text-lg max-w-xl mx-auto font-light leading-relaxed">
              Veja como pessoas reais transformaram suas vidas com os exercícios gratuitos — e depois foram muito além.
            </p>
          </div>

          {/* Stats de impacto */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
            {beforeAfterStats.map((stat, i) => (
              <div key={i} className="bg-cream-50 border border-gold-100 rounded-2xl p-5 text-center">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-full bg-gold-100">
                  <i className={`${stat.icon} text-lg text-gold-600`}></i>
                </div>
                <div className="font-display text-2xl font-bold text-charcoal-900 mb-1">{stat.value}</div>
                <div className="text-xs text-charcoal-500 leading-snug">{stat.label}</div>
              </div>
            ))}
          </div>

          {/* Depoimentos cards */}
          <div className="grid md:grid-cols-3 gap-8 mb-14">
            {testimonials.map((t, i) => (
              <div key={i} className="bg-cream-50 border border-gold-200/60 rounded-2xl overflow-hidden flex flex-col">
                {/* Header do card */}
                <div className="bg-charcoal-900 px-6 py-5 flex items-center gap-4">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-12 h-12 rounded-full object-cover flex-shrink-0 border-2 border-gold-400/40"
                  />
                  <div>
                    <div className="font-semibold text-cream-100 text-sm">{t.name}</div>
                    <div className="text-gold-400 text-xs">{t.role}</div>
                  </div>
                  <div className="ml-auto flex gap-0.5">
                    {[...Array(t.stars)].map((_, si) => (
                      <i key={si} className="ri-star-fill text-gold-400 text-xs"></i>
                    ))}
                  </div>
                </div>

                {/* Antes */}
                <div className="px-6 pt-5 pb-4 border-b border-gold-100 flex-1">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="w-5 h-5 rounded-full bg-charcoal-200 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-down-line text-charcoal-600 text-xs"></i>
                    </span>
                    <span className="text-xs font-bold text-charcoal-400 uppercase tracking-widest">Antes</span>
                  </div>
                  <p className="text-sm text-charcoal-500 leading-relaxed italic">&ldquo;{t.before}&rdquo;</p>
                </div>

                {/* Depois */}
                <div className="px-6 py-5">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="w-5 h-5 rounded-full bg-gold-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-up-line text-gold-600 text-xs"></i>
                    </span>
                    <span className="text-xs font-bold text-gold-600 uppercase tracking-widest">Depois</span>
                  </div>
                  <p className="text-sm text-charcoal-700 leading-relaxed font-medium">&ldquo;{t.after}&rdquo;</p>
                  <div className="mt-4 inline-flex items-center gap-2 bg-gold-50 border border-gold-200 px-3 py-1.5 rounded-full">
                    <i className="ri-leaf-line text-gold-500 text-xs"></i>
                    <span className="text-xs font-semibold text-gold-700">{t.result}</span>
                  </div>
                </div>

                {/* Exercício usado */}
                <div className="px-6 pb-5">
                  <div className="text-xs text-charcoal-400 font-medium">
                    Exercício: <span className="text-gold-600 font-semibold">{t.exercise}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Prova social + CTA */}
          <div className="bg-gradient-to-r from-charcoal-900 via-charcoal-800 to-charcoal-900 rounded-2xl p-10 text-center">
            <div className="flex justify-center gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-gold-400 text-xl"></i>
              ))}
            </div>
            <p className="font-display text-2xl text-cream-100 font-semibold mb-2">
              &ldquo;Os exercícios gratuitos foram tão poderosos que no mesmo dia assinei o plano completo.&rdquo;
            </p>
            <p className="text-gold-400 text-sm mb-8">— Ana Paula M., São Paulo</p>
            <Link
              to="/planos"
              className="inline-flex items-center gap-2 px-10 py-4 bg-gradient-to-r from-gold-500 to-gold-700 text-charcoal-900 rounded-full font-bold tracking-wide hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap"
            >
              Conhecer o Plano Completo
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA section */}
      <section className="py-20 px-6 bg-gradient-to-br from-charcoal-950 via-charcoal-900 to-charcoal-950 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-gold-500/5 rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-3xl mx-auto text-center relative z-10">
          <div className="w-12 h-px bg-gold-500/30 mx-auto mb-8"></div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
            Quer ir além das versões gratuitas?
          </h2>
          <p className="text-lg text-white/55 mb-10 font-light leading-relaxed">
            Desbloqueie protocolos completos, áudios guiados, workbooks em PDF e muito mais com acesso vitalício.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/planos#exercicios-pnl"
              className="px-10 py-4 bg-gradient-to-r from-gold-500 to-gold-700 text-charcoal-900 rounded-full font-bold tracking-wide hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap"
            >
              Ver Planos Completos
            </Link>
            <Link
              to="/planos"
              className="px-10 py-4 bg-white/8 text-white rounded-full font-bold tracking-wide hover:bg-white/14 transition-all whitespace-nowrap border border-gold-500/20"
            >
              Pacote 6 Técnicas — R$ 47
            </Link>
          </div>
          <p className="text-sm text-white/30 mt-6">
            Acesso vitalício · Garantia de 7 dias · Sem mensalidades
          </p>
        </div>
      </section>

      {/* Modal de exercício */}
      {exercicioModal && (
        <ExercicioModal
          exercicio={exercicioModal}
          onClose={() => setExercicioModal(null)}
        />
      )}
    </div>
  );
}
